import React from 'react';
import {BsFacebook,BsGithub,BsTwitter,BsLinkedin} from 'react-icons/bs'
import {TypeAnimation} from 'react-type-animation'
import { motion } from 'framer-motion';
import {fadeIn} from '../variants'
import { Link } from 'react-scroll';


const Banner = () => {
  return (<section id='home' className='min-h-[85vh] lg:min-h-[70vh] flex items-center'>
    <div className='container mx-auto'>
      <div className='flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12'>
        {/* text */}
        <div className='flex-1 text-center font-secondary lg:text-left'>
          <motion.h1 
              variants={fadeIn('up',0.3)} 
              initial='hidden' whileInView={"show"} 
              viewport={{once:false,amount:0.7}} 
              className='text-[55px] font-bold leading-[0.8] lg:text-[60px] lg:mt-12 '>
            IL<span>YAS</span>
          </motion.h1>
          <motion.div variants={fadeIn('up',0.4)} 
              initial='hidden' whileInView={"show"} 
              viewport={{once:false,amount:0.7}}  
              className='mb-5 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1]'>
            <span className='text-black mr-4'>I am a</span>
            <TypeAnimation sequence={[
              'Developer',
              2000,
              'Problem solver',
              2000,
            ]} speed={50} className='text-accent' wrapper='span' repeat={Infinity}/>
          </motion.div>
          <motion.p 
              variants={fadeIn('up',0.5)} 
              initial='hidden' whileInView={"show"} 
              viewport={{once:false,amount:0.7}}  
              className='mb-8 max-w-lg mx-auto lg:mx-0'>
            Hey, I am Ilyas DAHHOU a Software Engineering Student
            and a passionate Web developer from Morocco
          </motion.p>
          <motion.div 
              variants={fadeIn('up',0.6)} 
              initial='hidden' whileInView={"show"} 
              viewport={{once:false,amount:0.7}} 
              className='flex max-w-max gap-x-6 items-center mb-10 mx-auto lg:mx-0'>
                {/* link */}
                <Link to='contact' 
                activeClass='active' smooth={true} 
                  spy={true}><button className='btn btn-lg'>Contact me</button></Link>
            <a href='#' className='text-gradient btn-link'>My Portfolio</a>
          </motion.div>
          {/* social */}
          <motion.div 
              variants={fadeIn('down',0.7)} 
              initial='hidden' whileInView={"show"} 
              viewport={{once:false,amount:0.7}}  
              className='flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0'>
            <a  href='https://www.linkedin.com/in/ilyas-dahhou-b64229247/'>
              <BsLinkedin/>
            </a>
            <a href='https://www.facebook.com/ilyass.dahhou.7/'>
              <BsFacebook/>
            </a>
            <a href='https://github.com/dahhou-ilyas'>
              <BsGithub/>
            </a>
            <a href='https://twitter.com/DahhouIlyas?t=nTw5GUTvsLMYIQtzo5iDDA&s=08'>
              <BsTwitter/>
            </a>
          </motion.div>
        </div>
        {/* image */}
        <motion.div 
              variants={fadeIn('down',0.5)} 
              initial='hidden' whileInView={"show"} 
              className="home__img hidden lg:flex flex-1 max-w-[320px] lg:max-w-[482px]">
        </motion.div>
      </div>
    </div>
  </section>);
};

export default Banner;
